var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customerServiceDialogVisible)?_c('div',{staticClass:"dialog-customer-service"},[_c('i',{staticClass:"el-icon-close",on:{"click":_vm.onClickCloseIcon}}),_c('iframe',{staticClass:"dialog-customer-service__iframe",attrs:{"src":_vm.customerServiceURL,"title":"customer service","scrolling":"no"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }